var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWHat1NewHair3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "new-hair-3_1_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D0E09B",
    d: "M477.2,181.2c20.6,9.9,7.8,54.5,4.1,66.4c17.7-13.7,41.8-38.3,46.6-59.8c4.9-21.6,21.5-63.5-23.3-109.3 c-32.7-33.3-87.9-61-123.3-62c-39.4-1.2-107.7,16.3-138.7,34c-46.7,26.7-70,80.7-69.3,104c0.6,19.9,4.2,46.7,15.3,62 c7.4,10.1,22.1,22.1,36,22.7c-13.2-9.2-18-51.3,10.7-52.7c-12.8-16.6,44.2-18,53.5-18.8c39.7-3.4,81.6-7.8,121,1.3 C432.6,174.3,460.2,171,477.2,181.2"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "hats_new-hair-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "w-hat1_7_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#783C55",
    d: "M585.3,172.7c-5-1.2-10-2.6-14.9-4.2c-37.6-12.9-76-29.2-108.2-53.6c-0.6-30-11.1-60.3-37.2-79.9 c-26.2-18.1-58.2-18.1-87.3-14.2c-4.9,0.9-9.8,2-14.5,3.4c-14.3,4.2-27.7,10.5-39.1,18.6c-3.9,2.9-7.6,6.1-11,9.5s-6.7,7-9.6,10.9 c-2.9,4-5.6,8.2-7.9,12.7c-7.5,15.7-11.4,33.4-9.9,51c-28.8,39.5-78.4,59.4-123.9,75.9c-4.1,1.4-8.2,2.6-12.3,3.9 c41.2,25.6,92.7,15.3,136.2-0.5c4.8-1.5,9.5-3,14.3-4.5c19.1-5.9,38.4-11.3,57.9-13.9c5.6-0.8,11.2-1.3,16.9-1.6 c8.6,0.1,17.4,0.1,26.1,0.1c29.1,1.8,57.1,8.4,85.2,12.8c5.6,0.9,11.3,1.7,17,2.4c4.7,0.7,9.5,1.2,14.3,1.6s9.7,0.6,14.6,0.7 c35.1,1.4,72.8-7.2,100.3-29.5C590.1,173.8,587.7,173.3,585.3,172.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4F2335",
    d: "M462.2,114.9c-0.2-8.8-1.2-17.6-3.3-26.2c-5.2,0.8-10.4,1.5-15.5,2.2c-20.5,1.6-40.9,3.4-61.3,5.1 c-5.1,0.4-10.2,0.8-15.3,1.2c-3.8,0.2-7.6,0.3-11.5,0.5c-21.3,0.7-42.4,2.7-63.6,4.2c0.7-5.5,1.4-11,2.5-16.3 c1-5.2,2.2-10.3,3.8-15.3c8.4-22.8,27.6-43.6,51.3-50.7c-3.9,0.3-7.7,0.8-11.5,1.3c-4.9,0.9-9.8,2-14.5,3.4 c-14.3,4.2-27.7,10.5-39.1,18.6c-3.9,2.9-7.6,6.1-11,9.5s-6.7,7-9.6,10.9c-2.9,4-5.6,8.2-7.9,12.7c-7.5,15.7-11.4,33.4-9.9,51 c-28.8,39.5-78.4,59.4-123.9,75.9c-4.1,1.4-8.2,2.6-12.3,3.9c37.2,23.2,82.9,17,123.4,3.9c1.9-1,3.8-2,5.7-3.1 c8.3-4.9,16-10.8,22.6-17.5c15.9-14.3,22.3-32.2,25.7-51.3c46.7-0.9,94.2-5,141-8c10.8-1.2,21.5-2.8,32-5.3 c4.1-1,8.2-2.1,12.2-3.3C468.8,119.7,465.5,117.3,462.2,114.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392A19",
    d: "M459,88.7c-2.5,0.4-5,0.8-7.4,1.1c-0.3,0-0.5,0.1-0.8,0.1c-2.4,0.3-4.8,0.6-7.3,0.9 c-20.5,1.6-40.9,3.4-61.3,5.1c-5.1,0.4-10.2,0.8-15.3,1.2c-3.8,0.2-7.6,0.3-11.5,0.5c-2.6,0.1-5.3,0.2-7.9,0.3c-0.1,0-0.2,0-0.2,0 c-2.5,0.1-5,0.3-7.5,0.4c-0.3,0-0.6,0-1,0.1c-2.1,0.1-4.2,0.3-6.4,0.4c-0.9,0.1-1.8,0.1-2.7,0.2c-1.3,0.1-2.6,0.2-3.9,0.3 c-26.3,1.9-52.5,4.5-79,4.2c-1.2,7.1-1.6,14.3-1.2,21.5c37.3,0.7,74-4.6,111-5.8c3.8-0.2,7.6-0.4,11.5-0.5 c5.1-0.4,10.2-0.8,15.3-1.2c20.4-1.7,40.9-3.5,61.3-5.1c5.8-0.7,11.6-1.5,17.3-2.5C461.6,102.8,460.6,95.6,459,88.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#392A19",
    d: "M366.8,97.1c-3.8,0.2-7.6,0.3-11.5,0.5c-2.6,0.1-5.3,0.2-7.9,0.3c-0.1,0-0.2,0-0.2,0 c-2.5,0.1-5,0.3-7.5,0.4c-0.3,0-0.6,0-1,0.1c-2.1,0.1-4.2,0.3-6.4,0.4c-0.9,0.1-1.8,0.1-2.7,0.2c-1.3,0.1-2.6,0.2-3.9,0.3 c-11.4,0.8-22.7,1.8-34.1,2.6c-0.9,7.3-1.6,14.6-2.5,21.8c22.5-1.5,44.9-3.7,67.4-4.5c3.8-0.2,7.6-0.4,11.5-0.5 c1-0.1,2.1-0.2,3.1-0.3V96.8C369.8,96.9,368.3,97,366.8,97.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392A19",
    d: "M462,109.9c-0.4-7.2-1.4-14.3-3.1-21.3c-2.5,0.4-5,0.8-7.4,1.1c-0.3,0-0.5,0.1-0.8,0.1 c-2.4,0.3-4.8,0.6-7.3,0.9c-13.7,1-27.5,2.2-41.2,3.4v21.7c14.1-1.2,28.3-2.4,42.5-3.5C450.5,111.7,456.3,110.9,462,109.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.8,103.5c-1.2,7.1-1.6,14.3-1.2,21.5c14.6,0.3,29.1-0.4,43.6-1.4c0.9-7.2,1.6-14.6,2.5-21.8 C276.8,102.9,261.9,103.7,246.8,103.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8E6C45",
    d: "M382.1,95.9c-3.6,0.3-7.3,0.6-10.9,0.9v21.7c4.1-0.3,8.1-0.6,12.2-1c6.3-0.5,12.6-1.1,18.8-1.6V94.2 C395.5,94.8,388.8,95.3,382.1,95.9z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWHat1NewHair3);
export default __webpack_public_path__ + "static/media/w-hat1_new-hair3.7bb4611006d6c02a1dabcf8aada27ff3.svg";
export { ForwardRef as ReactComponent };